<template>
  <div>

    <div class="news d-flex align-center justify-center">
      <div class="list d-flex justify-center">
        <div class="item" v-for="(item, index) in list.records" :key="index" @click="handleToDetail(item.id)">
          <el-image v-if='!item.file1' class="image" :src="require('@/assets/images/news_01.jpg')"></el-image>
          <el-image v-if='item.file1' class="image" :src="imgurl+'/hogchain-boot/sys/common/static/'+item.file1"></el-image>
          <div class="info d-flex">
            <p class="flex-1 text-overflow">
               {{item.title}}
            </p>
            <span class="iconfont icon-arrowright"></span>
          </div>
        </div>
      </div>
    </div>

      <div class="pagination-box">
        <el-pagination :background='true' layout="prev, pager, next, total" :total="totals" :page-size="pageSize" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page='pageNo'>
        </el-pagination>
      </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleToDetail(e) {
      this.$router.push({path: '/news/news-detail?id='+e});
      // this.$router.push('/news/news-detail',params:{ id:e}})
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
      this.pageNo=val
      this.newslist()
    },
    newslist(){
      this.list=[]
        const url = this.url.url+'/hogchain-boot/hogchain/hotchainBusNews/list';
        this.$http.get(url, {
          params: {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
			column: "createTime",
			order: "desc",
          }
        }).then(
          response => {
            this.list=response.body.result
            if(!this.totals){
              this.totals=response.body.result.total
            }
          },

          response => {
            alert('请求失败');
          },
        );
    }
  },
  data() {
    return {
      model: '456456456456456',
      pageNo: 1,
      list:'',
      pageSize:9,
      totals:'',	  
	  imgurl:this.url.url
    }
  },
  mounted() {
    this.newslist()
  },
}
</script>

<style lang="scss" scoped>
.news {
  padding-top: 1.225rem;
  .list {
    width: 15rem;
    flex-wrap: wrap;
    /* padding-top: 1rem; */
    /* overflow: hidden; */
    .item {
      float: left;
      width: 4.75rem;
      background-color: #feffff;
      box-shadow: 0.025rem 0.025rem 0.05rem 0 rgba(153, 153, 153, 0.4);
      margin-right: 0.375rem;
      margin-bottom: 0.375rem;
      cursor: pointer;
      :hover {
        p,
        .icon-arrowright {
          color: #2373f0;
        }
      }
      &:nth-of-type(3n + 3) {
        margin-right: 0;
      }
      .image {
        display: block;
        width: 4.75rem;
        height: 3.125rem;
      }
      .info {
        width: 100%;
        height: 1rem;
        padding: 0.25rem;
        color: #666;
        p {
          padding-right: 0.125rem;
          line-height: 0.25rem;
          font-size: 0.225rem;
          box-sizing: border-box;
        }
        .icon-arrowright {
          line-height: 0.25rem;
          font-size: 0.225rem;
        }
      }
    }
  }
}

.pagination-box {
  width: 15rem;
  padding: 0.375rem 0 1rem;
  margin: 0 auto;
  text-align: right;
  ::v-deep .el-pagination {
    .btn-prev,
    .btn-next {
      min-width: 0.375rem;
      background-color: transparent;
      margin: 0 0.0625rem;
      .el-icon {
        font-size: 0.25rem;
      }
    }
    .el-pager {
      li {
        min-width: 0.375rem;
        margin: 0 0.0625rem;
        padding: 0 0.05rem;
        border-radius: 50%;
        font-size: 0.175rem;
        height: 0.35rem;
        line-height: 0.35rem;
      }
    }
  }
}
</style>
